/// <amd-module name="Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidgetComponents/AnalyticsSprintBurndownConstants" />
export class AnalyticsSprintBurndownConstants {
    // Note: This was traditionally associated with the config consumer, but this pattern is muddied with the re-use scenario across widgets.
    public static readonly featureName: string = "AnalyticsSprintBurndownWidget";

    /** Used to identify Analytics Service traffic requested by this widget in Kusto */
    public static readonly command: string = "SprintBurndown";
}
